import { useGLTF } from '@react-three/drei';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';

export default function Publics() {
    const modelsFilesd = [
        { path: './models/manif/manifd1.glb', nodeName: 'manifd1' },
        { path: './models/manif/manifd2.glb', nodeName: 'manifd2' },
        { path: './models/manif/manifd3.glb', nodeName: 'manifd3' },
        { path: './models/manif/manifd4.glb', nodeName: 'manifd4' },
        { path: './models/manif/manifd5.glb', nodeName: 'manifd5' },
    ];
    const modelsFilesg = [
        { path: './models/manif/manifg1.glb', nodeName: 'manifg1' },
        { path: './models/manif/manifg2.glb', nodeName: 'manifg2' },
        { path: './models/manif/manifg3.glb', nodeName: 'manifg3' },
        { path: './models/manif/manifg4.glb', nodeName: 'manifg4' },
    ];

    const modelsd = modelsFilesd.map(({ path }) => useGLTF(path));
    const modelsg = modelsFilesg.map(({ path }) => useGLTF(path));

    const location = useLocation();
    const groupRefsd = useRef([]);
    const groupRefsg = useRef([]);

    useEffect(() => {
        groupRefsd.current.forEach((group, index) => {
            if (group) {
                if (location.pathname === '/manifestants') {
                    gsap.to(group.position, {
                        x: 0,
                        duration: 4,
                        delay:  0.4 + index * 0.2,
                        ease: 'power2.inOut',
                    });
                } else {
                    gsap.to(group.position, {
                        x: 10,
                        duration: 4,
                        delay: index * 0.2,
                        ease: 'power2.inOut',
                    });
                }
            }
        });
        groupRefsg.current.forEach((group, index) => {
            if (group) {
                if (location.pathname === '/manifestants') {
                    gsap.to(group.position, {
                        x: 0,
                        duration: 4,
                        delay: 0.4 + index * 0.2,
                        ease: 'power2.inOut',
                    });
                } else {
                    gsap.to(group.position, {
                        x: -10,
                        duration: 4,
                        delay: index * 0.2,
                        ease: 'power2.inOut',
                    });
                }
            }
        });
    }, [location.pathname]);

    return (
        <>
            {modelsd.map((model, index) => (
                <group
                    key={index}
                    ref={(el) => (groupRefsd.current[index] = el)}
                    position={[10, 0, 0]}
                >
                    {model.nodes[modelsFilesd[index].nodeName] && (
                        <mesh
                            geometry={model.nodes[modelsFilesd[index].nodeName].geometry}
                            receiveShadow
                            onClick={(event) => event.stopPropagation()}
                            onPointerEnter={(event) => event.stopPropagation()}
                        >
                            <meshStandardMaterial color={0x392821} />
                        </mesh>
                    )}
                </group>
            ))}
            {modelsg.map((model, index) => (
                <group
                    key={index}
                    ref={(el) => (groupRefsg.current[index] = el)}
                    position={[-10, 0, 0]}
                >
                    {model.nodes[modelsFilesg[index].nodeName] && (
                        <mesh
                            geometry={model.nodes[modelsFilesg[index].nodeName].geometry}
                            receiveShadow
                            onClick={(event) => event.stopPropagation()}
                            onPointerEnter={(event) => event.stopPropagation()}
                        >
                            <meshStandardMaterial color={0x392821} />
                        </mesh>
                    )}
                </group>
            ))}
        </>
    );
}